<div class="playback-wrapper" *ngIf="src">
  <sn-fab-button class="close" matTooltip="Close Camera" (click)="remove.next(camera)">
    <sn-icon>close</sn-icon>
  </sn-fab-button>
  <sn-video-player
    class="playbackCam"
    width="100%"
    [src]="src"
    [local]="false"
    [autoplay]="false"
    [main]="true"
    [timestamp]="true"
    (init)="onPlayerInit($event)"
  >
    <sn-player-footer-row>
      <sn-player-progress-bar-control></sn-player-progress-bar-control>
    </sn-player-footer-row>
    <sn-player-footer-row>
      <sn-player-footer-section>
        <sn-player-play-control></sn-player-play-control>
        <sn-player-time-control></sn-player-time-control>
      </sn-player-footer-section>
      <sn-player-footer-section alignment="end">
        <sn-player-fullscreen-control></sn-player-fullscreen-control>
      </sn-player-footer-section>
    </sn-player-footer-row>
  </sn-video-player>
</div>
